<template>

  <div class="gallery relative h-full aspect-square" ref="gallery">
    <div class="aspect-[3/2]">
      <Transition>
          <picture v-if="elements[flipHolderOne]" class="gallery-element ">
            <source type="image/webp" :srcset="elements[flipHolderOne].webp " class="mr-8">
            <source type="jpg" :srcset="elements[flipHolderOne].jpg">
            <img loading="lazy"
                 :src="elements[flipHolderOne].src"
                 :alt="elements[flipHolderOne].title"
                 class="block"
                 :width="elements[flipHolderOne].width"
                 :height="elements[flipHolderOne].height"
            >
          </picture>
      </Transition>
    </div>
    <Transition>
      <picture v-if="elements[flipHolderTwo]"
               class="gallery-element absolute bottom-0 transform -translate-y-[1.5rem] right-0 -mr-8 w-3/5 h-auto">
        <source type="image/webp" :srcset="elements[flipHolderTwo].webp ">
        <source type="jpg" :srcset="elements[flipHolderTwo].jpg">
        <img loading="lazy"
             :src="elements[flipHolderTwo].src"
             :alt="elements[flipHolderTwo].title"
             class="block"
             :width="elements[flipHolderTwo].width"
             :height="elements[flipHolderTwo].height"
        >
      </picture>
    </Transition>

  </div>

</template>

<script>

import {onMounted, ref} from 'vue';

export default {
  name: "FlipGallery",
  props: {
    elements: {
      type: Array
    }
  },

  setup(props) {
    const gallery = ref(null);
    const flipHolderOne = ref(0);
    const flipHolderTwo = ref(1);

    function switchToNextImage(flipHolder, length) {
      const nextIndex = flipHolder.value + 2;

      flipHolder.value = null;

      setTimeout(() => {
        if (nextIndex > length - 1) {
          flipHolder.value = nextIndex - length;
        } else {
          flipHolder.value = nextIndex;
        }
      }, 400);
    }

    onMounted(() => {

      setInterval(() => {

        switchToNextImage(flipHolderOne, props.elements.length)

      }, 5000)

      setTimeout(() => {
        setInterval(() => {

          switchToNextImage(flipHolderTwo, props.elements.length)

        }, 5000)
      }, 2500)
    });


    return {
      gallery,
      flipHolderOne,
      flipHolderTwo
    }
  },

};
</script>

<style lang="postcss">


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

</style>

